import apiClient from '../api.js';
import { conToken } from '../autorizacion.js';

// Capa de servicios del PERFIL DOCENTE de un estudiante.
// Backend en capas: `UNICEN/modules/academico`. Solo SUPER y SECGRAL (el rol se
// verifica en la base: 403 si no corresponde, 401 si el usuario ya no está activo).
//
//   GET /academico/perfil-docente?unicodigo=&modo=todas|aprobadas
//       -> { data: { estudiante: { unicodigo, nombre },
//                    materias: [ { numero, cod_materia, materia, docente,
//                                  profesion, especialidad, gestion, nota,
//                                  estado } ] } }
//
//       `modo=todas` (por defecto) incluye las materias repetidas: una fila por
//       cada vez que se cursó. `modo=aprobadas` solo las aprobadas.
//       El docente sale del grupo en que se inscribió (desde 2/2024); las
//       materias anteriores vienen con docente, profesión y especialidad en
//       null. Si un grupo tuvo varios docentes se unen con " / ".
//
//       400 si falta `unicodigo`; 404 si el estudiante no existe.
//
// Solo lectura.

const resource = '/academico/perfil-docente';

const usePerfilDocenteApi = {
  obtenerPerfilDocente({ unicodigo, modo }) {
    return apiClient.get(resource, conToken({ params: { unicodigo, modo } }));
  },
};

export default usePerfilDocenteApi;
